module.exports = __webpack_public_path__ + "6189cc6dbd0ae97dd7c640f025b4bdfb.png";